import React from 'react'
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import Tr from 'translations/Translations';
import PropTypes from "prop-types";
import WorkableIconButton from "./WorkableIconButton";

function WorkableIconHighlightOffButton(
    {
        tooltip = Tr('delete'),
        ...props
    }) {
    return <WorkableIconButton
        tooltip={tooltip}
        Icon={HighlightOffIcon}
        {...props}
    />
}

WorkableIconHighlightOffButton.propTypes = {
    working: PropTypes.bool,
    disabled: PropTypes.bool,
    tooltip: PropTypes.string,
    hideTooltip: PropTypes.bool,
    color: PropTypes.string,
    onClick: PropTypes.func
}

export default WorkableIconHighlightOffButton;